import {AbstractControl, AbstractControlOptions, AsyncValidatorFn, UntypedFormGroup, ValidatorFn} from "@angular/forms";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";

export abstract class CustomFormGroup<S> extends UntypedFormGroup {
  readonly mergedState$: Observable<S>;

  constructor(public readonly initialState: S,
              controls: { [p in keyof Partial<S>]: AbstractControl },
              validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null,
              asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null) {
    super(controls, validatorOrOpts, asyncValidator);
    this.resetToInitialState();

    this.mergedState$ = this.valueChanges.pipe(
      map(() => this.getMergedState())
    );
  }

  resetToInitialState(): void {
    if (this.initialState) {
      this.patchValue(this.initialState);
    }
  }

  abstract getMergedState(): S;
}
